import { render } from "./thankYouPage.vue?vue&type=template&id=b56d1af2&scoped=true"
import script from "./thankYouPage.vue?vue&type=script&lang=js"
export * from "./thankYouPage.vue?vue&type=script&lang=js"

import "./thankYouPage.vue?vue&type=style&index=0&id=b56d1af2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56d1af2"]])

export default __exports__